module.exports = __webpack_public_path__ + "static/media/error-404.a0e51ed3.svg";